import axios from '../../http.service';
import cloneDeep from 'lodash/cloneDeep';
import * as TYPES from '../Enums/Script.Dates.Enums';

export const getScriptDatesCount = (appointmentTypes, year) => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/scripts/dates/count/${year}/${JSON.stringify(appointmentTypes)}`);

			return resp.status === 200
				? dispatch({
						type: TYPES.SCRIPT_DATES_COUNT,
						payload: resp.data
				  })
				: dispatch({
						type: TYPES.SCRIPT_DATES_ERROR,
						payload: resp.data
				  });
		} catch (error) {
			dispatch({
				type: TYPES.SCRIPT_DATES_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Script Date Count Data', error.message]
				}
			});
		}
	};
};

export const getScriptDatesData = (appointmentTypes, year, query, exportData = false, teamIds = [], isRefine = false, refineFields = [], groupUpdaterFields = []) => {
	return async (dispatch, getState) => {
		try {
			let selectedTypes = appointmentTypes, selectedTeamIds = teamIds;
			let isGroupUpdater = false, previewUpdate = [], isGroupUpdaterFilter = false;
			let preview_eMarkingStartDate =  null, preview_eMarkingEndDate = null
			let title = '', markingTeamCode = '', markingMethod = [], scriptDeliveryDate = '', scriptReturnDate = '', eMarkingStartDate = '', eMarkingEndDate = '';
			if(refineFields && refineFields.length > 0) {
				title = refineFields[0].title;
				markingTeamCode = refineFields[0].markingTeamCode;
				markingMethod = refineFields[0].markingMethod;
				scriptDeliveryDate = refineFields[0].scriptDeliveryDate;
				scriptReturnDate = refineFields[0].scriptReturnDate;
				eMarkingStartDate = refineFields[0].eMarkingStartDate;
				eMarkingEndDate = refineFields[0].eMarkingEndDate;
			}
			else {
				refineFields = [{ title, markingTeamCode, markingMethod, scriptDeliveryDate, scriptReturnDate, eMarkingStartDate, eMarkingEndDate }];
			}

			if(groupUpdaterFields && groupUpdaterFields.length > 0) {
				isGroupUpdater = groupUpdaterFields[0].isGroupUpdater;
				previewUpdate = groupUpdaterFields[0].previewUpdate;
				isGroupUpdaterFilter = groupUpdaterFields[0].isGroupUpdaterFilter;
				if(previewUpdate && previewUpdate.length > 0){
					preview_eMarkingStartDate = previewUpdate[0].eMarkingStartDate;
					preview_eMarkingEndDate = previewUpdate[0].eMarkingEndDate;
				}
				if(isGroupUpdaterFilter) {
					const scriptdates = getState().scriptdates;			
					selectedTypes = scriptdates.selectedTypes;
					selectedTeamIds = scriptdates.selectedTeamIds;
					appointmentTypes = scriptdates.groupUpdaterTypes;
					teamIds = scriptdates.groupUpdaterTeamIds;
				}
			}
			
			let resp = await axios.get(`/api/v2/scripts/dates/${year}/${JSON.stringify(appointmentTypes)}?pagination=${JSON.stringify(query)}`
			, {headers: {'teamIds': `${teamIds}`, 'title': `${title}`, 'markingTeamCode': `${markingTeamCode}`, 'markingMethod': `${markingMethod}` 
			, 'scriptDeliveryDate': `${scriptDeliveryDate}`, 'scriptReturnDate': `${scriptReturnDate}`, 'eMarkingStartDate': `${eMarkingStartDate}`, 'eMarkingEndDate': `${eMarkingEndDate}` }} );

			if (resp.status === 200) {
				let { data = {data: [], total: 0}, errors = [] } = resp.data;
				const dataTableTotal = data.total || 0;
				data = data.data.map(item => ({ 
					...item,
					markingTeamCode: (item.markingTeamCode || ''), 
					scriptDeliveryDate: (item.scriptDeliveryDate || ''), 
					scriptReturnDate: (item.scriptReturnDate || ''), 
					eMarkingStartDate: preview_eMarkingStartDate ? preview_eMarkingStartDate : (item.eMarkingStartDate || null), 
					eMarkingEndDate: preview_eMarkingEndDate ? preview_eMarkingEndDate : (item.eMarkingEndDate || null), 
					isSave: false
				}));
				const dataCopy = cloneDeep(data);

				if (!exportData) {
					const updated = getState().scriptdates.updated;
					data = data.map(o => {
						const matchData = updated.find(x => x.markingTeamId === o.markingTeamId);
						return matchData ? { ...o, ...matchData } : o;
					});
				}

				if (isRefine) {
					return dispatch({ type: TYPES.SCRIPT_DATES_GET_REFINE, payload: { refineData: data, errors } });
				}
				else if (isGroupUpdater) {
					return dispatch({ type: TYPES.SCRIPT_DATES_GET_GROUP_UPDATER, payload: { groupUpdaterData: data, errors } });
				}
				else {
					const payload = {
					data,
					dataCopy,
					errors,
					dataTableTotal,
					selectedTypes,
					selectedTeamIds,
					refineFields,
					groupUpdaterFields
					};
					
					dispatch({
						type: !exportData ? TYPES.SCRIPT_DATES_GET : TYPES.SCRIPT_DATES_GET_ALL,
						payload
					});
				}
			} else {
				dispatch({
					type: TYPES.SCRIPT_DATES_ERROR,
					payload: resp.data
			  	});
			}
		} catch (error) {
			return dispatch({
				type: TYPES.SCRIPT_DATES_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching Script Dates Data', error.message]
				}
			});
		}
	};
};

export const addUpdateToScriptDates = (field, val, row, updates = []) => {
	return dispatch => {
		try {
			let _updates;
			if (updates.filter(x => x.markingTeamId === row.markingTeamId).length > 0) {
				_updates = updates.map(x => {
					return x.markingTeamId !== row.markingTeamId ? x : { ...x, [field]: val };
				});
			} else {
				_updates = [ ...updates, row ];
			}
			dispatch({
				type: TYPES.SCRIPT_DATES_ADD_UPDATE,
				payload: { 
					updates: _updates, 
					errors: [] 
				}
			});
		} catch (err) {
			dispatch({
				type: TYPES.SCRIPT_DATES_ERROR,
				payload: { updates, errors: [err.message] }
			});
		}
	};
};

export const removeUpdate = (keyField, id, updates = []) => {
	return dispatch => {
		try {
			const _updates = updates.filter(update => update[keyField] !== id);
			dispatch({
				type: TYPES.SCRIPT_DATES_ADD_UPDATE,
				payload: { 
					updates: _updates, 
					errors: [] 
				}
			});
		} catch (err) {
			dispatch({
				type: TYPES.SCRIPT_DATES_ERROR,
				payload: { updates, errors: [err.message] }
			});
		}
	}
};

export const removeAllEdits = () => {
	return (dispatch, getState) => {
		const { scriptdates: { dataCopy } } = getState();
		const data = cloneDeep(dataCopy);
		dispatch({
			type: TYPES.SCRIPT_DATES_REMOVE_ALL_EDITS,
			payload: {
				data
			}
		});
	};
};

export const clearAllScriptDatesUpdates = () => dispatch => dispatch({ type: TYPES.SCRIPT_DATES_CLEAR_ALL_UPDATES, payload: {} });

export const saveUpdatedScriptDates = (appointmentTypes, year, updates) => {
	return async (dispatch, getState) => {
		try {
			if (updates.length <= 0)
				return dispatch({
					type: TYPES.SCRIPT_DATES_SAVE,
					payload: {
						message: 'Unable to Save Data',
						errors: ['No Changes to Save'],
						data: []
					}
				});

			let resp = await axios.put(`/api/v2/scripts/dates/${year}/${JSON.stringify(appointmentTypes)}`, { updates: updates });

			const { message = '', errors = [], data = [] } = resp.data;
			//_Get Data from redux store.
			let { groupUpdaterData } = getState().scriptdates;		
			if (errors.length == 0) {
				groupUpdaterData.forEach(item => item.isSave = true);
			}
			else {
				const failed_data = errors.map(item => ({ markingTeamId: item.markingTeamId })) || [];
				const tempUpdated = updates.map(item => ({ markingTeamId: item.markingTeamId })) || [];
				const partial_save_data = tempUpdated.filter(x => !failed_data.some(y => (x.markingTeamId == y.markingTeamId))) || [];	

				if(partial_save_data.length > 0){
					groupUpdaterData.forEach(item => {
						const updatedItem = partial_save_data.find(x => (x.markingTeamId == item.markingTeamId));
						if (updatedItem) {
							item.isSave = true;
						}
					});
				}
			}

			return dispatch({
				type: TYPES.SCRIPT_DATES_SAVE,
				payload: { message: '', data, errors: [], groupUpdaterData }
			});
		} catch (error) {
			dispatch({
				type: TYPES.SCRIPT_DATES_ERROR,
				payload: {
					data: [],
					errors: ['Error while saving updates', error.message]
				}
			});
		}
	};
};

export const clearUpdateScriptDateErrors = () => {
	return dispatch =>
		dispatch({
			type: TYPES.SCRIPTS_DATE_CLEAR,
			payload: { message: '', errors: [] }
		});
};

export const clearRefineData = () => dispatch => dispatch({ type: TYPES.SCRIPT_DATES_REFINE_CLEAR, payload: {} });

export const getGroupUpdaterUpdates = () => {
	return (dispatch, getState) => {
		const groupUpdaterData = getState().scriptdates.groupUpdaterData || [];	
		dispatch({ type: TYPES.SCRIPT_DATES_GROUP_UPDATER_UPDATES, payload: { groupUpdaterData } });
	};
};

export const setGroupUpdaterResultsDetails = (groupUpdaterTypes = [], groupUpdaterTeamIds = []) => {
	return dispatch => {
		dispatch({
			type: TYPES.SCRIPT_DATES_GROUP_UPDATER_FILTER,
			payload: { groupUpdaterTypes, groupUpdaterTeamIds }
		});
	};
};

export const clearGroupUpdaterData = () => dispatch => dispatch({ type: TYPES.SCRIPT_DATES_GROUP_UPDATER_CLEAR, payload: {} });

export const clearRefineFilters = () => dispatch => dispatch({ type: TYPES.SCRIPT_DATES_GROUP_UPDATER_CLEAR, payload: {} });
